module.exports = __webpack_public_path__ + "static/hotel-front-d6323a416c5e3f3886a3d76127afce6b.jpg";